import type { FormInputComponent } from '../types'

export type PreviewRoleType =
	| 'participant'
	| 'rater'
	| 'unsolicited'
	| 'primary_manager'
	| 'secondary_manager'
	| 'up'
	| 'down'
	| 'direct_reports'

export interface PreviewRoleOption {
	value: PreviewRoleType
	label: string
}

export const PREVIEW_ROLE_OPTIONS: PreviewRoleOption[] = [
	{ value: 'participant', label: 'Self Evaluator' },
	{ value: 'rater', label: 'Rater' },
	{ value: 'up', label: 'Upward' },
	{ value: 'down', label: 'Downward' },
	{ value: 'direct_reports', label: 'Direct Reports' },
	{ value: 'unsolicited', label: 'Unsolicited' },
	{ value: 'primary_manager', label: 'Manager' },
	{ value: 'secondary_manager', label: 'Secondary Manager' },
]

export interface RolePermission {
	read: boolean
	write: boolean
	reports: boolean
	optional: boolean
}

export interface ReportSubmission {
	label: string
	value: string
	calculatedRole?: PreviewRoleType
}

export interface Report {
	label: string
	submissions: ReportSubmission[]
	average?: string
}

export interface FilteredComponent extends Omit<FormInputComponent, 'children'> {
	read: boolean
	write: boolean
	reports: boolean
	optional: boolean
	reportOnly: boolean
	mockReports?: Report[]
	children: FilteredComponent[]
}
